// Kayıt formundaki telefon biçimi: (532)-123-45-67
export const PHONE_MASK_REGEX = /^\(\d{3}\)-\d{3}-\d{2}-\d{2}$/;

export const PHONE_FORMAT_HINT = "5xx xxx xx xx";

// Telefon maskesi: ilk hane 0 olamaz. Başa 0 yazan kişinin 0'ı yok sayılır ve numaranın
// kalan 10 hanesini eksiksiz girmesi gerekir ("0532..." yazınca "(053)-2..." diye kaymaz).
export const PHONE_MASK = "(X99)-999-99-99";
export const PHONE_MASK_FORMAT_CHARS = { 9: "[0-9]", X: "[1-9]" };

// Geçerli sayılanlar (boşluk, parantez ve tire serbest):
//  - 10 hane:            "(532)-123-45-67", "5321234567"
//  - başında 0, 11 hane: "05321234567", "0532 123 45 67"
//  - başında 90, 12 hane: "+90 532 123 45 67", "905321234567"
export const isPhoneValid = (phone) => {
  const value = (phone || "").trim();
  if (!/^\+?[\d\s()-]+$/.test(value)) return false;
  const digits = value.replace(/\D/g, "");
  if (value.startsWith("+") && !digits.startsWith("90")) return false;
  if (digits.length === 10) return !digits.startsWith("0");
  if (digits.length === 11) return digits.startsWith("0");
  if (digits.length === 12) return digits.startsWith("90");
  return false;
};
